import { connect } from 'react-redux';
import { SnackBar } from './SnackBar';
import { coreActions } from 'src/redux/core/coreActions';
import { getNotifications } from 'src/redux/core/coreSelectors';
var mapStateToProps = function (state) { return ({
    notifications: getNotifications(state),
}); };
var mapDispatchToProps = function (dispatch) { return ({
    addNotification: function (notification) { return dispatch(coreActions.addNotificationRequested(notification)); },
    removeNotification: function (notification) { return dispatch(coreActions.removeNotificationRequested(notification)); },
}); };
export default connect(mapStateToProps, mapDispatchToProps)(SnackBar);
